"use client";

import { env } from "@/common/env/client.mjs";

export const pageView = () => {
  window.dataLayer?.push({
    event: "pageView",
    pagePath: document.location.pathname,
  });
  window.gtag?.("config", env.NEXT_PUBLIC_GTAG_ID ?? "", {
    page_title: document.title,
    page_location: document.location.href,
    page_path: document.location.pathname,
    send_page_view: true,
  });
};
